import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Helping from "../../helpers/Helping";
import { setErrorFields, validateField } from "../../helpers/validationHelpers";
import { setProfileError, addCurrentRoute } from '../../actions/profile_action';
import Notification from "../layout/Notification";
import { create, update } from "../../services/rewards.service";
import { MESSAGE } from "../../config/index";
import LoadingButton from "../fields/LoadingButton";
import { API_URL } from '../../config/urls';
import jQuery from "jquery";
import $ from 'jquery';

const { CREATE, UPDATE } = MESSAGE;
class Create extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: API_URL.ADMIN_COLLECTION_API + "reward",
            pageTitle: "Add New Reward",
            buttonTitle: "Save",
            code: "",
            type: "",
            content: {},
            routeName: "",
            isLoading: true,
            btnIsDisable: false,
        };

        this.onUpdate = this.onUpdate.bind(this);
        this.onSave = this.onSave.bind(this);
        this.loadContent = this.loadContent.bind(this);
    }

    setErrorOnApiCall = () => {
        setProfileError(res => this.setState({ ...res }));
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    handleValueChange = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });

        if (name === "code") this.setState({ ...await validateField("string", name, value, "") });
        if (name === "type") this.setState({ ...await validateField("string", name, value, "") });
    }

    componentDidMount() {
        let that = this;
        this.setErrorOnApiCall();

        if (!this.props.id) {
            this.setState({
                isLoading: false
            });
        }
        if (this.props.id) {
            let id = this.props.id;

            that.setState({
                pageTitle: 'Edit Reward',
                buttonTitle: 'Update'
            });
            that.getById(id);
        }

        $(".close-slide").click(function () {
            that.resetForm();
            that.removeNetworkError();
            that.setState({
                pageTitle: "Add new reward",
                buttonTitle: 'Save'
            })
            that.props.closeEditModal();
        });
    }

    getById(id) {
        var $this = this;
        axios
            .get(this.state.url + `/${id}`, Helping.getConfig())
            .then(response => {
                let { payload } = response.data;
                $this.setState({
                    type: payload.type,
                    code: payload.code,
                    content: JSON.parse(payload.content),
                    isLoading: false
                });
            })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    $this.setState({
                        error_message: error.response.data.message,
                        error_type: "danger",
                        isLoading: false
                    });
                }
            });
    }

    resetForm = () => {
        this.setState({
            name: "",
            code: "",
            type: "",
            content: {},
            btnIsDisable: false,
            error_code_message: "",
            error_type_message: "",
        });
    }

    checkEmptyInputFields = () => {
        let { state } = this,
            formHasError = false;

        if (state.code === "") {
            let errorObject = setErrorFields("code", "Code is required.");
            this.setState(errorObject);
            formHasError = true;
        }

        if (state.type === "") {
            let errorObject = setErrorFields("type", "Please Select Type.");
            this.setState(errorObject);
            formHasError = true;
        }
        return formHasError;
    }

    scrollToTop = () => {
        $('.addButton-slide').animate({ scrollTop: 0 }, 'slow');
    }

    onSave(e) {
        e.preventDefault();

        let self = this,
            state = this.state,
            formHasError = this.checkEmptyInputFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        this.loadContent().then(response => {
            if (response.status === 200) {
                let content = response.payload;

                let data = {
                    code: state.code,
                    type: state.type,
                    content: JSON.stringify(content)
                };
                axios.post(API_URL.ADMIN_COLLECTION_API + "create-reward/", data, Helping.getConfig())
                    .then(response => {
                        self.props.create(response.data.payload);
                        self.setState(
                            {
                                error_message: Helping.getMessageString(CREATE, "reward"),
                                error_type: "success",
                                btnIsDisable: false
                            }, () => { this.scrollToTop(); this.resetForm() }
                        );
                    })
                    .catch(error => {
                        if (error.response) {
                            Helping.redirectToLogin(error);
                            self.setState({
                                error_message: error.response.data.message,
                                error_type: "danger",
                                btnIsDisable: false
                            }, () => this.scrollToTop())
                        }
                    })
            }
            else {
                this.setState({
                    error_message: response.message,
                    error_type: 'danger',
                    btnIsDisable: false
                }, () => this.scrollToTop())
            }
        })
    }

    onUpdate(e) {
        e.preventDefault();

        let self = this,
            state = this.state,
            id = this.props.id,
            formHasError = this.checkEmptyInputFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        this.loadContent().then(response => {
            if (response.status === 200) {
                let content = response.payload;

                let data = {
                    id: id,
                    code: state.code,
                    type: state.type,
                    content: JSON.stringify(content)
                };
                axios.post(API_URL.ADMIN_COLLECTION_API + "update-reward/", data, Helping.getConfig())
                    .then(response => {
                        self.props.update(response.data.payload);
                        self.setState(
                            {
                                error_message: Helping.getMessageString(UPDATE, "reward"),
                                error_type: "success",
                                btnIsDisable: false
                            }, () => { this.scrollToTop(); this.resetForm() }
                        );
                    })
                    .catch(error => {
                        if (error.response) {
                            Helping.redirectToLogin(error);
                            self.setState({
                                error_message: error.response.data.message,
                                error_type: "danger",
                                btnIsDisable: false
                            }, () => this.scrollToTop());
                        }
                    });
            }
            else {
                this.setState({
                    error_message: response.message,
                    error_type: 'danger',
                    btnIsDisable: false
                }, () => this.scrollToTop())
            }
        })
    }

    async loadContent() {
        try {
            let result = await axios.get(API_URL.ITEM_URL + `main-item/${this.state.code}`);

            if (result) {
                let { payload } = result.data;
                this.setState({
                    content: payload
                });
            }
            return await result.data;
        }
        catch (err) {
            return await err.response.data;
        }
    }

    render() {
        let content = this.state.content;

        return (
            <div class="addButton-slide right-slider addNew-rewards">
                <div class="slide-top">
                    <div class="slide-header">
                        <h4 class="title">{Helping.getTitleCase(this.state.pageTitle)}</h4>
                        <span class="caption">Add rewards' information into system.</span>
                    </div>
                    {/* <span class="close-slide">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                    </span> */}
                </div>

                {this.state.error_message &&
                    <Notification
                        type={this.state.error_type}
                        message={this.state.error_message}
                        callback={this.removeNetworkError}
                    />
                }

                <form action="" class="info">
                    <div class="form-group">
                        <label for="collectionCode">Code</label>
                        <input type="text" class={`form-control ${this.state.error_code_message ? 'error-input' : ''}`} name="code" id="collectionCode" value={this.state.code} onChange={(e) => this.handleValueChange(e)} />
                        <span className="error-msg">{this.state.error_code_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="collectionType">Type</label> <br />
                        <select class={`form-select ${this.state.error_type_message ? 'error-input' : ''}`} aria-label="Default select example" name="type"
                            id="collectionType" value={this.state.type} onChange={(e) => this.handleValueChange(e)}
                        >
                            <option value="" selected>Select Type...</option>
                            <option value="NFT">NFT</option>
                        </select>
                        <span className="error-msg">{this.state.error_type_message}</span>
                    </div>

                    {!jQuery.isEmptyObject(this.state.content) && (
                        <div class="rewards-content">
                            <label for="">Content</label> <br />
                            <div class="table-responsive items-tbl">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">ID</th>
                                            <th scope="col">Name</th>
                                            <th scope="col">Thumbnail</th>
                                            <th scope="col">Brand</th>
                                            <th scope="col">Assest</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr key={content.id}>
                                            <td scope="row">{content.id}</td>
                                            <td class="name">{content.name ? content.name : null}</td>
                                            <td>
                                                <div class="logoImg">
                                                    <img src={content.thumbnail_url ? content.thumbnail_url : null} alt="" class="img-fluid" />
                                                </div>
                                            </td>
                                            <td>{content.brand.name ? content.brand.name : null}</td>
                                            <td>{content.asset.name ? content.asset.name : null}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    <div class="slide-btn">
                        <div className="float-left">
                            <button class="close-slide custom-btn semi-dark-btn sm-btn" onClick={e => e.preventDefault()}>Close</button>
                        </div>

                        <div class="float-right">
                            {!this.props.id &&
                                <button class="custom-btn semi-dark-btn sm-btn" onClick={(e) => { e.preventDefault(); this.resetForm() }}>Reset</button>
                            }
                            {this.state.btnIsDisable ?
                                <LoadingButton class_name={"sm-btn"} />
                                :
                                this.props.id ? (
                                    <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onUpdate(e)}>{this.state.btnIsDisable ? "Loading..." : this.state.buttonTitle}</button>
                                ) : (
                                    <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onSave(e)}>{this.state.btnIsDisable ? "Loading..." : this.state.buttonTitle}</button>
                                )}
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        profile: state.profile,
        rewards: state.rewards
    };
};

const mapDispatchToProps = {
    addCurrentRoute,
    create,
    update
};

export default connect(mapStateToProps, mapDispatchToProps)(Create);
